import { initializeComponents, unloadComponents } from 'utils/initializeComponents';
import bust from 'utils/bust';

export const reflow = (element) => element.offsetHeight;

export const setPrefixedStyle = (element, property, value) => {
  const prefixes = ['', '-webkit-', '-moz-', '-ms-'];
  prefixes.forEach((prefix) => (element.style[prefix + property] = value));
};

export const setVendor = (element, property, value) => {
  const prefixes = ['-webkit-', '-moz-', '-ms-'];
  element.style[property] = value;

  prefixes.forEach((prefix) => (element.style[prefix + property] = value));
};

export const insertAfter = (newNode, referenceNode) => {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};
// eslint-disable-next-line complexity
export const closest = (elem, selector) => {
  const matchesSelector =
    elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;

  while (elem) {
    if (matchesSelector.bind(elem)(selector)) {
      return elem;
    }
    // eslint-disable-next-line no-param-reassign
    elem = elem.parentElement;
  }
  return false;
};

export const parseFromString = (string) => {
  const parser = new DOMParser();
  return parser.parseFromString(string, 'text/html');
};

export const getHTML = (url, container) => {
  return fetch(bust(url), { credentials: 'same-origin' })
    .then((response) => response.text())
    .then((text) => parseFromString(text).querySelector(container).innerHTML);
};

export const setHTML = (container, html) => {
  unloadComponents(container);

  container.innerHTML = html;

  // HTML may have data-initialzed attributes, while the elements are unloaded above
  // We remove the attributes before intializing again, so they are not skipped
  Array.from(container.querySelectorAll('[data-initialized]')).forEach((element) =>
    element.removeAttribute('data-initialized')
  );

  initializeComponents(container);
};

export const path = (url) => url.replace(window.origin, '');
